import React from 'react'

import { PaymentsByMonth } from '../../../../../common/generated/residentApiSchemas'
import { TargetTable } from '../TargetTable'

interface InvoiceTargetTablesProps {
  paymentsByTarget: PaymentsByMonth['paymentsByTarget']
  openCreditNotes: PaymentsByMonth['openCreditNotes']
}

export const InvoiceTargetTables: React.FC<InvoiceTargetTablesProps> = ({
  paymentsByTarget,
  openCreditNotes,
}) => {
  const invoiceUuids = [
    ...new Set([
      ...paymentsByTarget.map(({ invoiceUuid }) => invoiceUuid),
      ...openCreditNotes.map(({ invoiceUuid }) => invoiceUuid),
    ]),
  ]

  if (paymentsByTarget.length === 0 && openCreditNotes.length === 0) {
    return <TargetTable paymentsByTarget={[]} openCreditNotes={[]} />
  }

  return (
    <div>
      {invoiceUuids.map((invoiceUuid) => (
        <div
          className="mb-10 last:mb-0"
          key={invoiceUuid === null ? 'without-invoice' : invoiceUuid}
        >
          <TargetTable
            paymentsByTarget={paymentsByTarget.filter(
              (payment) => payment.invoiceUuid === invoiceUuid
            )}
            openCreditNotes={openCreditNotes.filter(
              (creditNote) => creditNote.invoiceUuid === invoiceUuid
            )}
          />
        </div>
      ))}
    </div>
  )
}
